"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BtSaveCardCheckbox = BtSaveCardCheckbox;
var _react = _interopRequireDefault(require("react"));
var _LabeledToggle = _interopRequireDefault(require("@/ui/atoms/LabeledToggle"));
/** Render the Basis Theory save-card option when the checkout capability is available. */
function BtSaveCardCheckbox(_ref) {
  var available = _ref.available,
    checked = _ref.checked,
    label = _ref.label,
    _onChange = _ref.onChange;
  if (!available) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center pt-4",
    "data-sentry-component": "BtSaveCardCheckbox",
    "data-sentry-source-file": "BtSaveCardCheckbox.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_LabeledToggle["default"], {
    id: "bt-save-card-toggle",
    label: label,
    checked: checked,
    onChange: function onChange() {
      _onChange(!checked);
    },
    "data-sentry-element": "LabeledToggle",
    "data-sentry-source-file": "BtSaveCardCheckbox.tsx"
  }));
}